// Estado de uma caixa para o agente principal: quem responde e se o robo ainda existe no Atende.
export const estadoDaCaixa = (caixa, personaId) => {
  if (caixa.outro_robo) return 'OUTRO_ROBO';
  if (!caixa.persona_id) return 'DESLIGADA';
  if (String(caixa.persona_id) !== String(personaId)) return 'OUTRA_PERSONA';
  if (caixa.robo === 'missing') return 'ROBO_SUMIU';
  return 'LIGADA';
};
